<template>
  <v-app>
    <v-app-bar app clipped-left clipped-right color="white">
      <v-app-bar-title>
        <v-img
          contain
          max-width="400"
          :src="require('@/assets/nexus-connect-logo.svg')"
        />
      </v-app-bar-title>
      <v-spacer />
      <v-app-bar-title>
        <v-img contain width="200" :src="require('@/assets/nexus-logo.png')" />
      </v-app-bar-title>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<style>
html {
  overflow-y: auto;
}
</style>

<script>
import fetchURLParam from "@/shared/url_params";
import apiOptions from "@/plugins/axios/axios_options";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",

  data() {
    return {
      fullscreen: false,
    };
  },

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "clients",
      "currentClient",
      "incompleteSubmissions",
    ]),

    submissionUID() {
      return this.$route.params.uid;
    },
  },

  methods: {
    ...mapActions([
      "setAccessToken",
      "reloadComplete",
      "setClients",
      "setCurrentClient",
      "setIncompleteSubmissions",
      "setInternationalToothConvention",
    ]),

    initializeApplication(accessToken) {
      this.setAccessToken(accessToken);
      this.$axios.defaults.headers.Authorization = `Bearer ${accessToken}`;
      let osteonSessionUID = this.$cookies.get("osteonSessionUID");
      if (this.$route.name !== "existingOrderForm" && osteonSessionUID) {
        this.$router.push({
          name: "existingOrderForm",
          params: { uid: osteonSessionUID },
        });
      }
      this.$axios
        .get("/ordering/clients/")
        .then((response) => {
          this.setClients(response.data);
          this.fetchSubmissions().then(() => {
            const targetSubmission = this.incompleteSubmissions.find(
              (submission) => submission.uid === this.submissionUID
            );
            if (targetSubmission) {
              const targetClient = this.clients.find(
                (client) => client.uid === targetSubmission.client_uid
              );
              this.setCurrentClient(targetClient);
            }
          });
        })
        .catch(() => {
          if (this.$route.name !== "authCallback") {
            this.$axios.defaults.headers.Authorization = null;
            this.$cookies
              .keys()
              .forEach((cookie) => this.$cookies.remove(cookie));
            return this.redirectToID();
          }
        });
    },

    redirectToID() {
      window.location = `${apiOptions.authURL}?client_id=${
        apiOptions.clientID
      }&response_type=token&redirect_uri=${encodeURIComponent(
        apiOptions.redirectURI
      )}`;
    },

    async fetchSubmissions() {
      return new Promise((resolve) => {
        const promises = [];
        const submissions = [];
        for (const client of this.clients) {
          promises.push(
            this.$axios
              .get(`/ordering/submissions/${client.uid}/`)
              .then((response) => {
                response.data.forEach((submission) => {
                  submissions.push({ ...submission, client_uid: client.uid });
                });
              })
          );
        }
        Promise.all(promises).then(() => {
          this.setIncompleteSubmissions(submissions);
          resolve();
        });
      });
    },
  },

  beforeMount() {
    let accessToken = this.$cookies.get("osteonAccessToken");
    if (this.$route.name === "existingOrderForm") {
      this.$cookies.set("osteonSessionUID", this.$route.params.uid);
    }
    if (accessToken) {
      this.initializeApplication(accessToken);
    } else {
      accessToken = fetchURLParam("access_token");
      const expiresInSecs = fetchURLParam("expires_in");
      const expiresInMSecs = expiresInSecs * 1000;
      const expiresAt = new Date(new Date().getTime() + expiresInMSecs);
      if (accessToken && expiresAt) {
        this.$cookies.config(expiresAt);
        this.$cookies.set("osteonAccessToken", accessToken);
        this.initializeApplication(accessToken);
      } else {
        this.redirectToID();
      }
    }
  },

  mounted() {
    const existingConvention = this.$cookies.get(
      "internationalToothConvention"
    );
    if (existingConvention) {
      this.setInternationalToothConvention(existingConvention);
    }
  },
};
</script>
